import axios from 'axios'

const fetchIdentities = async filter => {
  const url = `/api/v1/identities${
    filter ? filter + '&camundaId=false' : '?camundaId=false'
  }`
  return await axios.get(url)
}

const fetchIdentitie = async hexId => {
  const url = `/api/v1/identities/${hexId}`
  console.log(url)
  return await axios.get(url)
}

const deleteIdentity = async identityHexId => {
  await axios.delete(`/api/v1/identities/${identityHexId}`)
}

const fetchIdentifiedBots = async identity => {
  const { data } = await axios.get(`/api/v1/identities/${identity.hexId}/bots`)
  return data._embedded.bots
}

const addBotToIdentity = async (bot, identity) => {
  let data = `/api/v1/identities/${identity.hexId}`
  await axios.post(`/api/v1/bots/${bot.hexId}/identities`, data, {
    headers: {
      'Content-Type': 'text/uri-list'
    }
  })
}

const deleteBotFromIdentity = async (bot, identity) => {
  await axios.delete(`/api/v1/bots/${bot.hexId}/identities/${identity.hexId}`)
}

export default {
  fetchIdentities,
  deleteIdentity,
  fetchIdentitie,
  fetchIdentifiedBots,
  addBotToIdentity,
  deleteBotFromIdentity
}
